import { render } from "./app-modal-audit-trails-detail.vue?vue&type=template&id=34ab64a6"
import script from "./app-modal-audit-trails-detail.vue?vue&type=script&lang=js"
export * from "./app-modal-audit-trails-detail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/item/app-modal-audit-trails-detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34ab64a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34ab64a6', __exports__)) {
    console.log('reload')
    api.reload('34ab64a6', __exports__)
  }
  
  module.hot.accept("./app-modal-audit-trails-detail.vue?vue&type=template&id=34ab64a6", () => {
    console.log('re-render')
    api.rerender('34ab64a6', render)
  })

}


export default __exports__